<template>
  <div class="price-change-analysis">
    <h2>涨价降价房源筛选</h2>
    <div class="filter-section">
      <el-select
        v-model="selectedType"
        placeholder="请选择类型"
        @change="handleTypeChange"
      >
        <el-option
          v-for="item in typeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="generateExcel()"> 下载Excel </el-button>
    </div>
    <div>
      <el-table :data="paginatedData" style="width: 100%" border>
        <el-table-column prop="estate_name" label="楼盘名称" width="180">
        </el-table-column>
        <el-table-column prop="area_name" label="板块" width="120">
        </el-table-column>
        <el-table-column prop="area" label="面积" width="120">
        </el-table-column>
        <el-table-column
          prop="hang_price"
          label="总价（万）"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="unit_price"
          label="单价（万）"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="户型"
          prop="huxing"
          width="100"
          align="center"
        >
        <!-- <template slot="scope">
          {{ scope.row.bedroom }}室{{ scope.row.livingroom }}厅{{ scope.row.toilet }}卫
        </template> -->
        </el-table-column>
        <el-table-column prop="priceChange" label="变动情况" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allData.length"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceChangeAnalysis",
  data() {
    return {
      selectedType: "",
      typeOptions: [
        { value: "涨价金额", label: "涨价金额" },
        { value: "涨价幅度", label: "涨价幅度" },
        { value: "降价金额", label: "降价金额" },
        { value: "降价幅度", label: "降价幅度" },
      ],
      allData: [], // 存储所有数据
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    // 计算当前页的数据
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.allData.slice(start, end);
    },
  },
  methods: {
    handleTypeChange(value) {
      this.currentPage = 1; // 切换类型时重置页码
      this.fetchData(value);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 改变每页条数时重置到第一页
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    fetchData(type) {
      this.$axios
        .post(this.$url_prefix + "price/reduction/property", {
          sort_type: type,
        })
        .then((res) => {
          // 处理数据，添加户型字段
          this.allData = (res.data.list || []).map(house => ({
            ...house,
            huxing: house.bedroom + "室" + house.livingroom + "厅" + house.bathroom + "卫",
            unit_price: (house.unit_price / 10000).toFixed(2),
            priceChange: house.priceRiseLabel||house.markdowmLabel||'',
          }));
        });
    },
    generateExcel() {
      const data = this.allData;
      let ths = [
        "楼盘名称",
        "板块",
        "面积",
        "总价（万）",
        "单价（万）",
        "户型",
        "变动情况",
      ];
      let outKeys = [
        "estate_name",
        "area_name",
        "area",
        "hang_price",
        "unit_price",
        "huxing",
        "priceChange",
      ];
      this.$downloadExcel("涨价降价房源筛选", data, outKeys, ths);
    },
  },
};
</script>

<style scoped>
.price-change-analysis {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.filter-section {
  margin: 20px 0;
  display: flex;
  gap: 20px;
}

.el-select {
  width: 200px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/page/priceChangeAnalysis.vue